// get all
export const SHOW_ERROR_GETTING_PAYMENT_METHODS = 'SHOW_ERROR_GETTING_PAYMENT_METHODS';
export const CLEAR_ERROR_GETTING_PAYMENT_METHODS = 'CLEAR_ERROR_GETTING_PAYMENT_METHODS';
export const FLAG_GETTING_PAYMENT_METHODS = 'FLAG_GETTING_PAYMENT_METHODS';
export const GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS';
export const CLEAR_PAYMENT_METHODS = 'CLEAR_PAYMENT_METHODS';
export const FLAG_GETTING_PAYMENT_METHOD = 'FLAG_GETTING_PAYMENT_METHOD';
export const GET_PAYMENT_METHOD = 'GET_PAYMENT_METHOD';
export const CLEAR_PAYMENT_METHOD = 'CLEAR_PAYMENT_METHOD';
